import { useIsMobile } from "../hooks/useIsMobile";

export default function ContentContainer({ children }) {
  const isMobile = useIsMobile();
  return (
    <div
      className={`absolute top-[20vh] p-2 ${
        isMobile
          ? "w-full top-[10vh]"
          : "sm:left-[30vw] sm:w-[69vw] lg:left-[20vw] lg:w-[79vw]"
      }`}
    >
      {children}
    </div>
  );
}
